import type { Area } from 'react-easy-crop'

export const createImage = (url: string): Promise<HTMLImageElement | null> =>
  new Promise((resolve, reject) => {
    const image = new Image()
    image.addEventListener('load', () => resolve(image))
    image.addEventListener('error', (error) => reject(error))
    image.src = url
  })

//TODO: Zoom is not working
export async function getCroppedImg(imageSrc: string, pixelCrop: Area, zoom: number) {
  const image = await createImage(imageSrc)
  if (!image) return null

  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')

  if (!ctx) {
    return null
  }

  canvas.width = pixelCrop.width
  canvas.height = pixelCrop.height

  const scaleX = image.naturalWidth / image.width
  const scaleY = image.naturalHeight / image.height

  const sourceWidth = (pixelCrop.width / zoom) * scaleX
  const sourceHeight = (pixelCrop.height / zoom) * scaleY

  const sourceX = pixelCrop.x * scaleX
  const sourceY = pixelCrop.y * scaleY

  ctx.drawImage(image, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, canvas.width, canvas.height)

  return new Promise<string>((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error('Canvas is empty'))
          return
        }
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onloadend = () => resolve(reader.result as string)
        reader.onerror = reject
      },
      'image/jpeg',
      1, // JPEG quality
    )
  })
}
